import React, { useMemo } from 'react';
import { Grid, Typography } from '@mui/material';
import MemoizedPortfolioItem from './MemoizedPortfolioItem';
import TradesRow from '../trades/TradesRow';

const PortfolioTradesList = ({ 
  trades = [], 
  searchText, 
  sortType,
  tabValue,
  priceChangeConfig
}) => {

  // Filter and sort trades 
  const filteredAndSortedTrades = useMemo(() => {
    // Apply search filter
    let filteredTrades = trades;
    if (searchText) {
      filteredTrades = filteredTrades.filter((trade) =>
        trade.script.name.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    // Apply sorting
    switch (sortType) {
      case 'atoz':
        return [...filteredTrades].sort((a, b) => 
          a.script.name.localeCompare(b.script.name)
        );
      case 'lastUpdated':
        return [...filteredTrades].sort((a, b) => 
          new Date(b.updatedAt) - new Date(a.updatedAt)
        );
      default:
        return filteredTrades;
    }
  }, [trades, searchText, sortType]);

  // If no trades, show message
  if (!filteredAndSortedTrades.length) {
    return (
      <Typography
        variant="h6"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          textAlign: 'center',
          padding: 4,
          width: '100%'
        }}
      >
        {tabValue === 0 ? 'NO ACTIVE TRADES' : 'NO CLOSED TRADES'}
      </Typography>
    );
  }

  // Render appropriate list based on tab
  return (
    <Grid container>
      {filteredAndSortedTrades.map((trade) => (
        tabValue === 0 ? (
          <MemoizedPortfolioItem
            key={trade?._id || trade?.script?._id}
            trade={trade}
            priceChangeConfig={priceChangeConfig}
            closeFromPortfolio
          />
        ) : (
          <Grid item xs={12} key={trade?._id || trade?.script?._id}>
            <TradesRow trade={trade} showTime={false} />
          </Grid>
        )
      ))}
    </Grid>
  );
};

export default React.memo(PortfolioTradesList);
